<ap-header [type]="'transparent'" [compact]="false" [hasLogo]="false" [styleClass]="isDarkTheme ? 'gtw-header-nav gtw-dark-theme' : 'gtw-header-nav'">

    <ng-template ngTemplate="title">
        <div class="d-flex align-items-center header-title-section">
            <div class="client-logo-wrapper">
                @if (logo_client) {
<img class="clientLogo" [src]="logo_client" alt="Client Logo"
                    (error)="hideLogoOnError($event)">
}
                @if (clientDropdownItems?.length) {
<ap-dropdown
                    class="client-logo-dropdown"
                    [styleClass]="'client-logo-dropdown'"
                    [listId]="'gtw-client-logo-dropdown-list'"
                    [list]="clientDropdownItems"
                    [selectType]="'single'"
                    [title]="''"
                    [hideTitleOnInput]="true"
                    [inputAriaLabel]="'Client'"
                    [(ngModel)]="selectedClientItem"
                    (onSelect)="changeClient($event)">
                    @for (item of clientDropdownItems; track $index) {

                        <ap-dropdown-list-item
                            #dropdownListItem
                            [item]="item"
                            [ariaLabel]="item.ariaLabel"
                            (onSelectItem)="onDropdownSelectItem($event)">
                        </ap-dropdown-list-item>
                    
}
                </ap-dropdown>
}
            </div>
            <div class="font-weight-medium gtw-brand-label-wrapper">{{name}}</div>
        </div>
    </ng-template>

    <ng-template ngTemplate="content">
        <div class="meDropdownAndBreadcrumbsContainer">
            <div class="business-selection-container" (gtwClickOutside)="closeBusinessDropdown($event)">
                <div class="business-selection-dropdown" [ngClass]="{'business-dropdown-active' : showBusinessMenu}" (click)="showBusinessMenu = !showBusinessMenu">
                    <span>{{ selectedApplication || '-' }}</span> -
                    <span>{{ selectedTaxYear || '-' }}</span> -
                    <span>{{ selectedScenario?.scenario_desc || selectedScenario?.text || '-' }}</span> -
                    <span><span class="totalMeCount">{{ selected?.length || 0 }}</span> Business Selected</span>
                    @if (!showBusinessMenu) {
<span class="Appkit4-icon icon-down-chevron-outline business-chevron"></span>
}
                    @if (showBusinessMenu) {
<span class="Appkit4-icon icon-up-chevron-outline business-chevron"></span>
}
                </div>
                @if (showBusinessMenu) {
<div class="business-selection-dropdown-data">
                    <div class="business-labels">
                        <span>Application</span>
                    </div>
                    @if (applicationDropdownItems?.length) {
<ap-dropdown
                        class="header-selection-dropdown"
                        [list]="applicationDropdownItems"
                        [selectType]="'single'"
                        [title]="''"
                        [hideTitleOnInput]="true"
                        [style]="'width:100%'"
                        [inputAriaLabel]="'Application'"
                        [(ngModel)]="selectedApplicationItem"
                        (onSelect)="channelSelection($event)">
                        @for (item of applicationDropdownItems; track $index) {

                            <ap-dropdown-list-item
                                #dropdownListItem
                                [item]="item"
                                [ariaLabel]="item.ariaLabel"
                                (onSelectItem)="onDropdownSelectItem($event)">
                            </ap-dropdown-list-item>
                        
}
                    </ap-dropdown>
}

                    <div class="business-labels">
                        <span>Tax Year</span>
                    </div>
                    @if (taxYearDropdownItems?.length) {
<ap-dropdown
                        class="header-selection-dropdown"
                        [list]="taxYearDropdownItems"
                        [selectType]="'single'"
                        [title]="''"
                        [hideTitleOnInput]="true"
                        [style]="'width:100%'"
                        [inputAriaLabel]="'Tax Year'"
                        [(ngModel)]="selectedTaxYearItem"
                        (onSelect)="taxYearSelection($event)">
                        @for (item of taxYearDropdownItems; track $index) {

                            <ap-dropdown-list-item
                                #dropdownListItem
                                [item]="item"
                                [ariaLabel]="item.ariaLabel"
                                (onSelectItem)="onDropdownSelectItem($event)">
                            </ap-dropdown-list-item>
                        
}
                    </ap-dropdown>
}

                    <div class="business-labels">
                        <span>Scenario</span>
                    </div>
                    @if (scenarioDropdownItems?.length) {
<ap-dropdown
                        class="header-selection-dropdown"
                        [list]="scenarioDropdownItems"
                        [selectType]="'single'"
                        [title]="''"
                        [hideTitleOnInput]="true"
                        [style]="'width:100%'"
                        [inputAriaLabel]="'Scenario'"
                        [(ngModel)]="selectedScenarioItem"
                        (onSelect)="scenarioSelection($event, true)">
                        @for (item of scenarioDropdownItems; track $index) {

                            <ap-dropdown-list-item
                                #dropdownListItem
                                [item]="item"
                                [ariaLabel]="item.ariaLabel"
                                (onSelectItem)="onDropdownSelectItem($event)">
                            </ap-dropdown-list-item>
                        
}
                    </ap-dropdown>
}

                    @if (selectedScenario.scenario_type_code == 'EXAM') {
<div class="business-labels">
                        <span>Issue Id</span>
                    </div>
}
                    @if (selectedScenario.scenario_type_code == 'EXAM' && isIssueListLoaded && issuesDropdownItems?.length) {
<ap-dropdown class="header-selection-dropdown"
                       
                        [list]="issuesDropdownItems"
                        [selectType]="'single'"
                        [title]="''"
                        [hideTitleOnInput]="true"
                        [style]="'width:100%'"
                        [inputAriaLabel]="'Issue Id'"
                        [(ngModel)]="selectedIssueItem"
                        (onSelect)="issueSelection($event)">
                        @for (item of issuesDropdownItems; track $index) {

                            <ap-dropdown-list-item
                                #dropdownListItem
                                [item]="item"
                                [ariaLabel]="item.ariaLabel"
                                (onSelectItem)="onDropdownSelectItem($event)">
                            </ap-dropdown-list-item>
                        
}
                    </ap-dropdown>
}

                    <div class="business-labels business-labels-with-actions">
                        <span>Business</span>
                        <span class="business-actions">
                            <span class="business-action-link" (click)="selectAll()">Select All</span>
                            <span class="business-action-link" (click)="unselectAll()">Unselect All</span>
                        </span>
                    </div>

                    @if (filterss.loading) {
<div style="display: flex; align-items: center; justify-content: center; width: 100%; min-height: 80px;">
                        <div class="loader"></div>
                    </div>
}

                    @if (!filterss.loading) {
<div class="global-me-container">
                        @for (me of menuObj1; track $index) {
<div class="me-container ap-my-spacing-2">
                            <ap-checkbox [(ngModel)]="me.selected"
                                [ariaLabel]="me.name || 'Business entity'"
                                (onChange)="selectedMe($event, me, true)">
                                <span>{{me.name || '-'}}</span>
                            </ap-checkbox>
                            @if (me.children && me.numSelected > 0) {
<span class="subMeCount float-right">{{me.numSelected}}</span>
}
                        </div>
}
                        @if (showSubBusinessMenu) {
<div class="sub-me-container customScroll">
                            @for (subMe of childMenuObj; track $index) {
<div class="ap-my-spacing-2">
                                <ap-checkbox [styleClass]="'a-mx-8'"
                                    [(ngModel)]="subMe.selected"
                                    [ariaLabel]="subMe.name || 'Sub business entity'"
                                    (onChange)="selectedMe($event, subMe, false)">
                                    <span>{{subMe.name || '-'}}</span>
                                </ap-checkbox>
                                @if (subMe.children) {
<div class="sub-me-child-container">
                                    @for (subChildMe of subMe.children; track $index) {
<div class="ap-my-spacing-2">
                                        <ap-checkbox [styleClass]="'a-my-8'"
                                            [(ngModel)]="subChildMe.selected"
                                            [ariaLabel]="subChildMe.name || 'Child business entity'"
                                            (onChange)="selectedMe($event, subChildMe, false)">
                                            <span>{{subChildMe.name || '-'}}</span>
                                        </ap-checkbox>
                                    </div>
}
                                </div>
}
                            </div>
}
                        </div>
}
                    </div>
}
                </div>
}
            </div>
            <div class="breadcrumbsBlock">
                <ap-breadcrumb [styleClass]="'gtw-header-breadcrumb'">
                    @for (label of breadCrumbLink; track $index; let last = $last) {
<ap-breadcrumb-item>
                        @if (last) {
<span aria-current="page" tabindex="-1">{{label}}</span>
} @else {
<span tabindex="0">{{label}}</span>
}
                    </ap-breadcrumb-item>
}
                </ap-breadcrumb>
            </div>
        </div>
        @if (showBusinessMenu) {
<div class="mask" (click)="showBusinessMenu = false"></div>
}
    </ng-template>

    <ng-template ngTemplate="options">
        <div class="header-options-wrapper" (gtwClickOutside)="isNotifPanel = false; showNotificationsPanel = false">
            <gtw-external-link [base-urls]="baseURLs"></gtw-external-link>

            <span class="link-icon" tabindex="0" (click)="isActive('client-landing-page')" ap-tooltip [tooltipContent]="'Clients'" [direction]="'top'">
                <span class="Appkit4-icon icon-building-outline"></span>
            </span>

            <span class="link-icon has-count-badge" tabindex="0" (click)="isActive('messages')">
                <span class="Appkit4-icon Appkit4-icon icon-email-outline" ap-tooltip [tooltipContent]="'Messages'" [direction]="'top'"></span>
                <ap-badge [styleClass]="'header-count-badge'" [value]="messageCount" [backgroundColor]="'#f78300'" [fontColor]="'#ffffff'" [size]="'small'"></ap-badge>
            </span>

            <span class="link-icon" tabindex="0" (click)="showNotificationsPanel = !showNotificationsPanel" ap-tooltip [tooltipContent]="'Favourites'" [direction]="'bottom-left'" [tooltipId]="'header-favourites'" ariaDescribedby="header-favourites">
                <svg width="2rem" height="1.6rem" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="cursor:pointer;">
                    <g stroke="gray" stroke-width="1" fill="none" fill-rule="evenodd">
                        <path fill="#999999" d="m 19.933963,26.415565 c 2.717705,-2.718753 3.566746,-6.597866 2.545198,-10.041364 l 2.225241,-2.22531 2.214641,2.214713 4.429276,-4.429419 L 20.104543,0.69005442 15.675261,5.1194724 17.888942,7.3341813 15.664659,9.5594916 C 12.221275,8.5379113 8.3413166,9.3860157 5.6236122,12.10477 l -2.0450243,2.044121 6.1331454,6.133336 -8.77953412,8.779812 c -0.56474284,0.564761 -0.56474284,1.48033 0,2.044124 0.56474282,0.564758 1.48028172,0.564758 2.04502432,0 l 8.7795355,-8.779807 6.132183,6.133337 z" class="pin-outline-icon-stroke" style="fill: #999999; fill-opacity: 0; stroke-width: 0.963736; stroke-miterlimit: 4; stroke-dasharray: none; stroke-opacity: 1; paint-order: fill markers stroke;">
                        </path>
                    </g>
                </svg>
            </span>
            <div class="dropdown-menu dropdown-menu-left a-shadow-sm border-0 a-user-setting-panel-one" [ngClass]="{'show':showNotificationsPanel}" style="right: 100px !important; left: inherit; top: 3rem !important;">
                <div class="dropdown-title">
                    My Pins
                </div>
                <ul class="user-infor-list" cdkDropList (cdkDropListDropped)="onDrop($event)">
                    @for (screen of favScreens; track $index) {
<div>
                        <li (click)="loadClickedScreen(screen)" class="user-infor-list-item" style="display: flex;" cdkDrag>
                            <div class="ellipsis-wrapper">
                                @if (screen.SCREENS_CATEGORY_LIST == "2") {
<img class="img-class" src="assets/img/tile-view-icons/Batch-Import.png"/>
}
                                @if (screen.SCREENS_CATEGORY_LIST == "9") {
<img class="img-class" src="assets/img/tile-view-icons/Dashboards.png"/>
}
                                @if (screen.SCREENS_CATEGORY_LIST == "7") {
<img class="img-class" src="assets/img/tile-view-icons/Diagnostics.png"/>
}
                                @if (screen.SCREENS_CATEGORY_LIST == "3") {
<img class="img-class" src="assets/img/tile-view-icons/Form-schedule.png"/>
}
                                @if (screen.SCREENS_CATEGORY_LIST == "1") {
<img class="img-class" src="assets/img/tile-view-icons/Report.png"/>
}
                                @if (screen.SCREENS_CATEGORY_LIST == "6") {
<img class="img-class" src="assets/img/tile-view-icons/setup-mapping.png"/>
}
                                @if (screen.SCREENS_CATEGORY_LIST == "5") {
<img class="img-class" src="assets/img/tile-view-icons/sourcing.png"/>
}
                                <span>{{screen.SCREEN_NAME}}</span>
                            </div>
                            <span class="actionIcons">
                                <span>
                                    <span class="material-icons screen-icon pinIcon">push_pin</span>
                                </span>
                                <span class="Appkit4-icon icon-menu-outline outlineIcon"></span>
                            </span>
                        </li>
                    </div>
}
                </ul>
                <div class=""></div>
            </div>

            <span class="link-icon" tabindex="0" (click)="isActive('help')" ap-tooltip [tooltipContent]="'Help'" [direction]="'top'">
                <span class="Appkit4-icon icon-help-question-outline"></span>
            </span>

            <span class="link-icon" tabindex="0" ap-tooltip [tooltipContent]="'Themes'" [direction]="'bottom-left'" [tooltipId]="'header-themes'" ariaDescribedby="header-themes">
                @if (isDarkTheme) {
<span class="Appkit4-icon icon-brightness-outline" (click)="setTheme('white')"></span>
}
                @if (!isDarkTheme) {
<span class="Appkit4-icon material-icons" (click)="setTheme('black')">dark_mode</span>
}
            </span>
        </div>
    </ng-template>

    <ng-template ngTemplate="user">
        <div class="avatar-container">
            <span class="avatar-container-chevron Appkit4-icon icon-down-chevron-fill" (click)="onAvatarChevronClick($event)"></span>
            <ap-avatar
                [name]="userInitials"
                diameter="40"
                borderWidth="0"
                [withDropdown]="true"
                [list]="avatarDropdownList"
                [ariaLabel]="'User menu'"
                [role]="'button'">
                <ng-template ngTemplate="dropdownTemp">
                    <div class="avatar-dropdown-header">Welcome {{display_name}}</div>
                    @for (item of avatarDropdownList; track $index) {

                        <ap-dropdown-list-item
                            [item]="item"
                            (onSelectItem)="onAvatarSelect($event)">
                            @if (item.iconName) {
<ng-template ngTemplate="prefixTemp">
                                <span class="Appkit4-icon icon-{{item.iconName}}"></span>
                            </ng-template>
}
                        </ap-dropdown-list-item>
                    
}
                    <div class="avatar-dropdown-footer">
                        <ap-button [btnType]="'primary'" [label]="'LOG OUT'" [compact]="true" (onClick)="singOut()"></ap-button>
                    </div>
                </ng-template>
            </ap-avatar>
        </div>
    </ng-template>

</ap-header>

<div class="a-nav-toggler d-sm-none d-flex">
    <a class="a-link-no-interaction a-nav-toggler-icon-wrapper text-right ml-2"
        (click)="showNavTogglerDiv()" (keyup.enter)="showNavTogglerDiv()" tabindex="0" (keydown.tab)="navTogglerDivClose($event)">
        <span class="Appkit4-icon Appkit4-icon icon-vertical-more-fill"></span>
    </a>
    @if (navTogglerDiv) {

        <div class="dropdown-menu dropdown-menu-right a-shadow-sm a-user-setting-panel-one w-25"
            style="display: flex;">
            <ul class="user-infor-list border-0">
                <li class="user-infor-list-item" (click)="activeNavToggler()">
                    <span class="Appkit4-icon Appkit4-icon icon-help-question-outline"></span> Feature 1
                </li>
                <li class="user-infor-list-item" (click)="activeNavToggler()">
                    <span class="Appkit4-icon Appkit4-icon icon-survey-outline"></span> Feature 2
                </li>
                <li class="user-infor-list-item" (click)="activeNavToggler()">
                    <span class="Appkit4-icon Appkit4-icon a-font-14 icon-grid-view-outline"></span> Feature 3
                </li>
            </ul>
        </div>
        <div class="mask" (click)="navTogglerDiv = false"></div>
    
}
</div>
